<div class="question_content"
    [class.answered]="this.questionAnswered" 
    (click)="this.toggleQuestionText()"
    >
    <div class="question_infos">
        <div class="question_title">{{'QUESTION.TITLE' | translate}} <span class="tester_name">{{this.testerName}}</span></div>
        <div class="question_date">{{'QUESTION.CREATION_DATE' | translate}} {{this.dateCreation | demoozDateToString}}</div>
    </div>
    
    <ion-icon class="question_status_icon" [name]="(this.questionAnswered ? 'checkmark-circle' : 'help-circle')"></ion-icon>
        
    @if(this.displayQuestionText){
        <div class="question_text_content">
            <div class="question_text">&ldquo; {{this.question.content}} &rdquo;</div>
            
            @if(this.questionAnswered){
                <div class="answer_content">
                    <div class="answer_date">{{'QUESTION.ANSWER_SENDED' | translate}} {{this.dateAnswer | demoozDateToString}}</div>
                    <div class="answer_text">&ldquo; {{this.question.responses[0].response}} &rdquo;</div>
                </div>
            }
            @else{
                <div class="question_actions">
                    <demooz-button type="button" label="{{'QUESTION.BUTTON_ANSWER' | translate}}" [withMargin]="false" (click)="this.answerQuestion($event)"/> 
                </div>
            }
        </div>
    }
    
</div>
